import React, { useState } from 'react';
import Sidebar from './components/layout/Sidebar';
import MarketMovers from './pages/market-movers/MarketMovers';
import DealFinder from './pages/deal-finder/DealFinder';
import Arbitrage from './pages/arbitrage/Arbitrage';
import PriceChecker from './pages/price-checker/PriceChecker';
import GradingChecker from './pages/grading-checker/GradingChecker';
import './index.css';

function App() {
  const [activeTab, setActiveTab] = useState('market-movers');
  const [selectedCard, setSelectedCard] = useState<string | null>(null);

  const openCard = (cardId: string) => {
    setSelectedCard(cardId);
    setActiveTab('price-checker');
  };

  const renderPage = () => {
    switch (activeTab) {
      case 'market-movers': return <MarketMovers onCardClick={openCard} />;
      case 'deal-finder': return <DealFinder onCardClick={openCard} />;
      case 'arbitrage': return <Arbitrage onCardClick={openCard} />;
      case 'price-checker': return <PriceChecker initialCardId={selectedCard} />;
      case 'grading-checker': return <GradingChecker />;
      default: return <MarketMovers onCardClick={openCard} />;
    }
  };

  return (
    <div className="flex min-h-screen bg-dark">
      <Sidebar activeTab={activeTab} onTabChange={setActiveTab} />
      <main className="flex-1 p-8">
        {renderPage()}
      </main>
    </div>
  );
}

export default App;
